import styled, { css } from "styled-components";

import { AiAssistantChatMessageAuthor } from "types/aiAssistant";

import { ButtonsContainer, ListSection, PrimaryButton, SecondaryButton } from "uikit";
import { DotLoader } from "uikit/Loader";
import { TextBase, TextMixin } from "uikit/Typography";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;
  max-height: 100%;
  padding-right: 4px;
  overflow-x: hidden;
  overflow-y: auto;
  margin-top: auto;

  &::-webkit-scrollbar {
    width: 4px;
  }

  &::-webkit-scrollbar-thumb {
    background-color: ${({ theme }) => theme.colors.colorsNew.gray["400"]};
    border-radius: 4px;
  }

  &::-webkit-scrollbar-track {
    background-color: ${({ theme }) => theme.colors.colorsNew.gray["100"]};
  }
`;

export const StyledDotLoader = styled(DotLoader)`
  width: fit-content;
`;

export const AiChatItemContainer = styled.div<{ $author: AiAssistantChatMessageAuthor }>`
  display: flex;
  flex-direction: column;
  gap: 4px;

  ${({ $author }) =>
    $author === AiAssistantChatMessageAuthor.USER &&
    css`
      align-self: flex-end;
    `}
`;

export const ACICHeader = styled.div<{ $author: AiAssistantChatMessageAuthor }>`
  display: flex;
  gap: 4px;
  ${({ $author }) =>
    $author === AiAssistantChatMessageAuthor.USER &&
    css`
      align-self: flex-end;
    `}

  ${TextBase} {
    &.author-name {
      &::after {
        content: "";
        display: inline-block;
        width: 3px;
        height: 3px;
        border-radius: 50%;
        background-color: ${({ theme }) => theme.colors.colorsNew.gray[400]};
        margin-left: 4px;
        vertical-align: middle;
      }
    }
  }
`;

export const ACICContent = styled.div<{ $author: AiAssistantChatMessageAuthor }>`
  border-radius: 16px 16px 16px 0;
  padding: 10px;
  background-color: ${({ theme }) => theme.colors.colorsNew.gray[200]};
  max-width: 358px;

  ${({ $author }) =>
    $author === AiAssistantChatMessageAuthor.USER &&
    css`
      align-self: flex-end;
      background-color: ${({ theme }) => theme.colors.colorsNew.gray[600]};

      p,
      span,
      h1,
      h2,
      h3,
      h4,
      h5,
      h6,
      ul,
      ol,
      li {
        color: ${({ theme }) => theme.colors.colorsNew.base.white};
        white-space: pre-wrap;
        word-wrap: break-word;
        overflow-wrap: break-word;
      }
    `}
`;

export const AiChatSuggestedActions = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: 8px;
`;

export const AiChatSuggestedActionContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: fit-content;
  padding: 10px;
  border-radius: 100px;
  background-color: ${({ theme }) => theme.colors.colorsNew.base.white};
  border: 1px solid ${({ theme }) => theme.colors.colorsNew.gray[300]};

  &:hover {
    background-color: ${({ theme }) => theme.colors.colorsNew.gray[100]};
    cursor: pointer;
  }
`;

export const MarkdownContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;

  h2 {
    color: ${({ theme }) => theme.colors.colorsNew.gray["900"]};
    font-size: ${({ theme }) => theme.size.h24};
    font-weight: ${({ theme }) => theme.fontWeight.bold};
    line-height: ${({ theme }) => theme.lineHeight.lh130};
  }

  h3 {
    color: ${({ theme }) => theme.colors.colorsNew.gray["900"]};
    font-size: ${({ theme }) => theme.size.t16};
    font-weight: ${({ theme }) => theme.fontWeight.bold};
    line-height: ${({ theme }) => theme.lineHeight.lh130};
  }

  ul,
  ol {
    list-style-type: disc;
    padding-inline-start: 16px;
  }

  li {
    font-size: ${({ theme }) => theme.size.t14};
    font-weight: ${({ theme }) => theme.fontWeight.regular};
    line-height: ${({ theme }) => theme.lineHeight.lh140};
  }

  strong {
    font-weight: 600;
  }

  p {
    ${TextMixin};
    font-size: ${({ theme }) => theme.size.t14};
    white-space: pre-wrap;
    word-wrap: break-word;
    overflow-wrap: break-word;
  }
`;

export const PayrollSubmissionSummaryContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const PayrollSubmissionSummaryContainerInner = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  gap: 10px;
  flex-wrap: wrap;
  padding: 12px;
  border-radius: 8px;
  background-color: ${({ theme }) => theme.colors.colorsNew.base.white};
  border: 1px solid ${({ theme }) => theme.colors.colorsNew.gray[300]};
`;

export const PayrollSubmissionSummaryCell = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  width: 48%;
`;

export const PayrollSubmissionSummaryWarningSection = styled(ListSection)``;

export const SubmitPayrollAiButton = styled(PrimaryButton)`
  width: 140px;
`;

export const CancelSubmitPayrollAiButton = styled(SecondaryButton)`
  width: 140px;
`;

export const BtnsWrapper = styled(ButtonsContainer)`
  &.center {
    justify-content: center;
  }
`;
